/* Northman chat assistant widget. No dependencies. Config from #northman-chat (snippets/northman-chat.liquid).
   Listens for CustomEvent 'northman:chat-request' (detail: { sku, field, handle? }) to open and seed a length/dimension request. */
(function () {
  'use strict';
  var root = document.getElementById('northman-chat');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var API = (root.dataset.api || '').replace(/\/+$/, '');
  if (!API) return;
  var GREETING = root.dataset.greeting || "Hi! I'm Sophie from the Northman team. I can help with fitment, kits, stock, orders and shipping — ask away.";
  var HANDLE = root.dataset.productHandle || '';
  var PTITLE = root.dataset.productTitle || '';
  var MAX = 800;
  var KEY = 'northman-chat:v1';
  var ALLOWED_HOSTS = [location.hostname, 'northmansuspension.com', 'www.northmansuspension.com', 'zvqtg7-dk.myshopify.com', 'northman-suspension.myshopify.com'];

  var state = load();
  var busy = false;

  function load() {
    try { var s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (s && s.v === 1) return s; } catch (e) {}
    return { v: 1, sessionId: '', open: false, msgs: [] };
  }
  function save() {
    try { state.msgs = state.msgs.slice(-40); sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  // ---- safe mini-markdown: escape everything, then allow **bold**, [text](url), bare URLs, "- " lists ----
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function safeUrl(u) {
    try {
      var url = new URL(u, location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:' && url.protocol !== 'tel:') return null;
      if (url.protocol === 'tel:') return url.href;
      // Shopify file CDN: keep absolute https (PDFs/guides). Path must be /s/files/ only.
      var CDN_HOSTS = ['cdn.shopify.com', 'cdn.shopifycdn.com'];
      if (CDN_HOSTS.indexOf(url.hostname) !== -1) {
        if (url.protocol !== 'https:') return null;
        if (!/^\/s\/files(\/|$)/.test(url.pathname)) return null;
        return url.href;
      }
      if (ALLOWED_HOSTS.indexOf(url.hostname) === -1) return null;
      // Same store: keep the visitor on the current domain (myshopify or northmansuspension.com)
      return url.pathname + url.search + url.hash;
    } catch (e) { return null; }
  }
  function link(href, text) {
    var u = safeUrl(href);
    return u ? '<a href="' + esc(u) + '">' + text + '</a>' : text;
  }
  function inline(s) {
    var out = esc(s);
    out = out.replace(/\[([^\]]{1,200})\]\((https?:\/\/[^\s)]+|\/[^\s)]*)\)/g, function (m, t, h) { return link(h.replace(/&amp;/g, '&'), t); });
    out = out.replace(/(^|[\s(])(https?:\/\/[^\s<)]+[^\s<).,;:!?])/g, function (m, pre, h) { return pre + link(h.replace(/&amp;/g, '&'), esc(h.replace(/^https?:\/\/[^/]+/, '') || h)); });
    out = out.replace(/\*\*([^*]{1,200})\*\*/g, '<strong>$1</strong>');
    // Phone tel: linkify: add Northman number here once Sophie/Reade confirm it.
    return out;
  }
  function md(text) {
    var lines = String(text || '').split(/\n/), html = '', list = null;
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i].replace(/^>\s?/, '');
      var m = l.match(/^\s*(?:[-*•]|(\d+)[.)])\s+(.*)$/);
      if (m) {
        var tag = m[1] ? 'ol' : 'ul';
        if (list !== tag) { if (list) html += '</' + list + '>'; html += '<' + tag + '>'; list = tag; }
        html += '<li>' + inline(m[2]) + '</li>';
        continue;
      }
      if (list) { html += '</' + list + '>'; list = null; }
      if (l.trim()) html += '<p>' + inline(l) + '</p>';
    }
    if (list) html += '</' + list + '>';
    return html;
  }

  // ---- DOM ----
  var ICON_CHAT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/><path d="M8.5 11h.01M12 11h.01M15.5 11h.01"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_SEND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  var el = document.createElement('div');
  el.className = 'hkc' + (root.dataset.hideMobile === 'true' ? ' hkc--hide-mobile' : '');
  el.innerHTML =
    '<button type="button" class="hkc__launcher" aria-expanded="false" aria-controls="hkc-panel" aria-label="Chat with us">' + ICON_CHAT + '<span class="hkc__label">Chat with us</span></button>' +
    '<div class="hkc__panel" id="hkc-panel" role="dialog" aria-modal="false" aria-label="Chat with Sophie from the Northman team">' +
      '<div class="hkc__head"><div class="hkc__avatar" aria-hidden="true">S</div><div><div class="hkc__title">Northman team</div><div class="hkc__sub">Sophie</div></div>' +
      '<button type="button" class="hkc__close" aria-label="Close chat">' + ICON_X + '</button></div>' +
      '<div class="hkc__log" aria-live="polite"></div>' +
      '<div class="hkc__ai">I\'m Sophie, Northman\'s AI assistant. I can check fitment, specs, stock levels and adjustment guides for you. Want a person? Just ask.</div>' +
      '<form class="hkc__form" novalidate><label class="visually-hidden" for="hkc-input" style="position:absolute;left:-9999px">Message</label>' +
        '<textarea id="hkc-input" class="hkc__input" rows="1" maxlength="' + MAX + '" placeholder="' + (window.matchMedia('(max-width:640px)').matches ? 'Type your question…' : 'Ask about fitment, orders or shipping…') + '"></textarea>' +
        '<button type="submit" class="hkc__send" aria-label="Send">' + ICON_SEND + '</button></form>' +
      '<div class="hkc__foot">Rather talk? Use our <a href="/pages/contact">contact page</a><span class="hkc__privacy">We save chats to help us look after you better.</span></div>' +
    '</div>';
  document.body.appendChild(el);

  var launcher = el.querySelector('.hkc__launcher'), panel = el.querySelector('.hkc__panel'), log = el.querySelector('.hkc__log');
  var form = el.querySelector('.hkc__form'), input = el.querySelector('.hkc__input'), send = el.querySelector('.hkc__send');

  function scroll() { log.scrollTop = log.scrollHeight; }
  function bubble(role, text) {
    var row = document.createElement('div');
    row.className = 'hkc__msg hkc__msg--' + (role === 'user' ? 'user' : 'bot');
    var b = document.createElement('div');
    b.className = 'hkc__bubble';
    if (role === 'user') b.textContent = text; else b.innerHTML = md(text);
    row.appendChild(b); log.appendChild(row);
    return row;
  }
  function render() {
    log.innerHTML = '';
    if (PTITLE) { var c = document.createElement('div'); c.className = 'hkc__context'; c.textContent = 'Viewing: ' + PTITLE; log.appendChild(c); }
    bubble('bot', GREETING);
    state.msgs.forEach(function (m) { bubble(m.r, m.t); });
    scroll();
  }

  function setOpen(open) {
    state.open = open; save();
    el.classList.toggle('hkc--open', open);
    launcher.setAttribute('aria-expanded', String(open));
    var mobile = window.matchMedia('(max-width:640px)').matches;
    document.documentElement.classList.toggle('hkc-lock', open && mobile);
    if (!open) schedule();
    if (open) { el.style.bottom = ''; render(); setTimeout(function () { if (!mobile) input.focus(); }, 60); } else launcher.focus();
  }

  function ask(text) {
    text = String(text || '').trim().slice(0, MAX);
    if (!text || busy) return;
    busy = true; send.disabled = true;
    state.msgs.push({ r: 'user', t: text }); save();
    bubble('user', text);
    var typing = bubble('bot', ''); typing.querySelector('.hkc__bubble').innerHTML = '<span class="hkc__typing" aria-label="Typing"><i></i><i></i><i></i></span>';
    scroll();
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 60000);
    fetch(API + '/api/chat', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: ctrl ? ctrl.signal : undefined,
      body: JSON.stringify({ sessionId: state.sessionId, message: text, page: location.origin + location.pathname, productHandle: HANDLE })
    }).then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        if (d.sessionId) state.sessionId = d.sessionId;
        return d.reply || "Sorry, I couldn't get an answer just then. Please use our contact page: /pages/contact";
      })
      .catch(function () { return "Sorry, I'm having trouble connecting. Please use our contact page: /pages/contact"; })
      .then(function (reply) {
        clearTimeout(timer);
        typing.remove();
        state.msgs.push({ r: 'bot', t: reply }); save();
        bubble('bot', reply); scroll();
        busy = false; send.disabled = false;
      });
  }

  launcher.addEventListener('click', function () { setOpen(true); });
  el.querySelector('.hkc__close').addEventListener('click', function () { setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) setOpen(false); });
  form.addEventListener('submit', function (e) { e.preventDefault(); var v = input.value; input.value = ''; input.style.height = ''; ask(v); });
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit')); } });
  input.addEventListener('input', function () { input.style.height = 'auto'; input.style.height = Math.min(110, input.scrollHeight) + 'px'; });

  // Step out of the way while the theme's cart drawer / mobile menu is open
  function themeOverlayOpen() {
    return !!document.querySelector('.mini-cart[aria-hidden="false"], #mini-cart[aria-hidden="false"], .drawer[aria-hidden="false"], .mobile-menu[aria-hidden="false"], .popover[aria-hidden="false"]');
  }
  var mo = new MutationObserver(function () { el.style.display = themeOverlayOpen() && !state.open ? 'none' : ''; });
  mo.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });

  // Mobile: keep the bubble clear of the buy box (quantity, Add to cart, checkout buttons). When it would cover one,
  // lift it just above that element; if that would push it past 60% of the screen, tuck it below instead.
  var AVOID = '.product-form__add-button, .product-form__payment-container, .shopify-payment-button, .quantity-selector, ' +
    'button[name="add"], button[name="checkout"], .cart-recap__checkout, .mini-cart__button-container, [data-hkc-avoid]';
  var BASE = 14, SIZE = 56, GAP = 10, raf = 0;
  function place() {
    raf = 0;
    if (state.open || !window.matchMedia('(max-width:640px)').matches) { el.style.bottom = ''; return; }
    var vw = window.innerWidth, vh = window.innerHeight, base = BASE;
    var rects = Array.prototype.map.call(document.querySelectorAll(AVOID), function (n) { return n.getBoundingClientRect(); })
      .filter(function (r) { return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < vh; });
    for (var pass = 0; pass < 4; pass++) {
      var top = vh - base - SIZE, bottom = vh - base, left = vw - BASE - SIZE, right = vw - BASE, hit = null;
      for (var i = 0; i < rects.length; i++) {
        var r = rects[i];
        if (r.left < right && r.right > left && r.top < bottom + GAP && r.bottom > top - GAP) { hit = r; break; }
      }
      if (!hit) break;
      var above = vh - hit.top + GAP;
      if (above + SIZE <= vh * 0.6) base = above;
      else { base = Math.max(BASE, vh - hit.bottom - GAP - SIZE); if (base === BASE) break; }
    }
    el.style.bottom = base === BASE ? '' : base + 'px';
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(place); }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  setTimeout(place, 300);


  // KONI / product "Request" pills: open chat and seed a dimension/length question
  window.addEventListener('northman:chat-request', function (ev) {
    var d = (ev && ev.detail) || {};
    var sku = d.sku || d.SKU || '';
    var field = d.field || d.dimension || 'length';
    var parts = ['Could you please share the'];
    parts.push(String(field || 'dimensions'));
    parts.push('for');
    if (sku) parts.push('SKU ' + String(sku));
    else parts.push('this product');
    parts.push('? Thanks.');
    var msg = parts.join(' ').replace(/\s+/g, ' ').trim();
    if (!state.open) setOpen(true);
    else render();
    setTimeout(function () {
      input.value = msg;
      input.style.height = 'auto';
      input.style.height = Math.min(110, input.scrollHeight) + 'px';
      try { input.focus(); } catch (e) {}
    }, 80);
  });

  if (state.open) setOpen(true);
})();
